/**
 * File types the Archive upload controls accept (REQ-005, FE-5-17)
 * Location: frontend/src/utils/archiveUploadTypes.js
 *
 * One list for both upload controls, the main Archive (Archive.js) and a
 * project's page (ProjectDetailPage.js), which had drifted apart. PDF,
 * PowerPoint and Word .docx are searchable (BE-5-31 added .docx). Older .doc and
 * .ppt are still accepted: the backend stores them and, if it cannot index one,
 * marks it failed with a readable reason the Archive shows (FE-5-15).
 */

export const ARCHIVE_UPLOAD_EXTENSIONS = ['.pdf', '.ppt', '.pptx', '.doc', '.docx'];

export const ARCHIVE_UPLOAD_MIME_TYPES = [
  'application/pdf',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

/** Value for an upload control's `accept` attribute. */
export const ARCHIVE_UPLOAD_ACCEPT = ARCHIVE_UPLOAD_EXTENSIONS.join(',');

/** Short user-facing list for upload hints. */
export const ARCHIVE_UPLOAD_FORMATS_LABEL = 'PDF, PowerPoint, Word (.docx)';

/**
 * @param {{ name?: string, type?: string }} file - a File or antd upload file
 * @returns {boolean} true if the Archive accepts this file
 */
export const isAllowedArchiveFile = (file) => {
  const name = file?.name || '';
  const dot = name.lastIndexOf('.');
  const extension = dot >= 0 ? name.slice(dot).toLowerCase() : '';
  return ARCHIVE_UPLOAD_MIME_TYPES.includes(file?.type) || ARCHIVE_UPLOAD_EXTENSIONS.includes(extension);
};
